import { render, staticRenderFns } from "./DetectionEventItem.vue?vue&type=template&id=2b6e534a&scoped=true"
import script from "./DetectionEventItem.vue?vue&type=script&lang=js"
export * from "./DetectionEventItem.vue?vue&type=script&lang=js"
import style0 from "./DetectionEventItem.vue?vue&type=style&index=0&id=2b6e534a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6e534a",
  null
  
)

export default component.exports